import { type JSX } from 'react';
import { useTranslation } from 'react-i18next';
import analytics from '@common/utils/analytics';

export interface TranslatedProps {
  id: string;
  defaultMessage?: string;
  values?: { [key: string]: Date | string | number; };
  tagName?: keyof JSX.IntrinsicElements;
  className?: string;
  ns?: string | string[];
  'data-testid'?: string;
  anchor?: string;
}

let useTitles = false;
if (APP_TYPE !== 'alexa') {
  const areWeTestingWithJest = () => process.env.JEST_WORKER_ID !== undefined;
  analytics.addActionForEnableTranslationLogger((enabled) => {
    useTitles = enabled && !areWeTestingWithJest();
  });
}

function Translated({
  id,
  tagName: Tag = 'span',
  values,
  className = '',
  ns,
  defaultMessage,
  anchor,
  ...rest
}: Readonly<TranslatedProps>) {
  const { t, ready } = useTranslation(ns);
  let text = defaultMessage ?? id;
  if (ready) {
    text = t(id, defaultMessage || id, values ?? {}); // NOSONAR:S6606
  }

  return (
    <Tag
      className={className || undefined}
      id={anchor}
      title={useTitles ? id : undefined}
      data-name={text}
      {...rest}
    >
      {text}
    </Tag>
  );
}

export default Translated;
